var _rect, _rect2, _rect3, _rect4, _path, _path2, _rect5, _rect6, _rect7, _rect8, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 257,
    viewBox: "0 0 241 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35.7393,
    y: 193.67,
    width: 169.521,
    height: 62.8,
    rx: 13.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 94.7393,
    y: 206.67,
    width: 94.95,
    height: 6.58322,
    rx: 3.29161,
    fill: "#1B3554"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 94.7393,
    y: 218.67,
    width: 69.93,
    height: 6.58322,
    rx: 3.29161,
    fill: "#1B3554"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 94.7393,
    y: 236.67,
    width: 27.1528,
    height: 6.58322,
    rx: 3.29161,
    fill: "#1B3554"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1504 232.392C74.6616 232.392 81.5614 225.514 81.5614 217.031C81.5614 208.547 74.6616 201.67 66.1504 201.67C57.6391 201.67 50.7393 208.547 50.7393 217.031C50.7393 225.514 57.6391 232.392 66.1504 232.392Z",
    fill: "#BAC2CB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6788 222.73C63.972 223.024 64.3553 223.17 64.7393 223.17C65.1233 223.17 65.5066 223.024 65.7998 222.73L73.3 215.23C73.8858 214.645 73.8858 213.695 73.3 213.109C72.7142 212.523 71.7647 212.523 71.1789 213.109L64.7393 219.548L61.2997 216.109C60.7139 215.524 59.7644 215.524 59.1786 216.109C58.5929 216.695 58.5929 217.645 59.1786 218.23L63.6788 222.73Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 35.7393,
    y: 120.672,
    width: 169.521,
    height: 62.8,
    rx: 13.5,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 94.7393,
    y: 133.672,
    width: 94.95,
    height: 6.58322,
    rx: 3.29161,
    fill: "#1B3554"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 94.7393,
    y: 145.672,
    width: 69.93,
    height: 6.58322,
    rx: 3.29161,
    fill: "#1B3554"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 94.7393,
    y: 163.672,
    width: 27.1528,
    height: 6.58322,
    rx: 3.29161,
    fill: "#1B3554"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1504 159.394C74.6616 159.394 81.5614 152.516 81.5614 144.033C81.5614 135.549 74.6616 128.672 66.1504 128.672C57.6391 128.672 50.7393 135.549 50.7393 144.033C50.7393 152.516 57.6391 159.394 66.1504 159.394Z",
    fill: "#BAC2CB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6788 149.732C63.972 150.026 64.3553 150.172 64.7393 150.172C65.1233 150.172 65.5066 150.026 65.7998 149.732L73.3 142.232C73.8858 141.646 73.8858 140.697 73.3 140.111C72.7142 139.525 71.7647 139.525 71.1789 140.111L64.7393 146.55L61.2997 143.111C60.7139 142.526 59.7644 142.526 59.1786 143.111C58.5929 143.697 58.5929 144.647 59.1786 145.232L63.6788 149.732Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2393 16.7548L191.761 36.8419C199.217 37.9829 205.261 43.1933 205.261 48.4715V83.7299C205.261 89.0081 199.217 94.2109 191.761 95.3425L51.2393 110.259C43.7835 111.211 35.7393 104.953 35.7393 95.056V31.9426C35.7393 22.0452 42.7835 15.7941 50.2393 16.7548Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.0309 45.5387L186.398 51.683C188.216 51.8158 189.689 53.0581 189.689 54.4577C189.689 55.8572 188.216 56.9222 186.398 56.8365L98.0309 52.8711C96.213 52.7936 94.7393 51.0723 94.7393 49.0262C94.7393 46.9802 96.213 45.4187 98.0309 45.5387Z",
    fill: "#1B3554"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.0309 58.9041L161.378 60.44C163.196 60.4857 164.669 61.8009 164.669 63.3774C164.669 64.954 163.196 66.2321 161.378 66.2323L98.0309 66.2365C96.213 66.2366 94.7393 64.5781 94.7393 62.532C94.7393 60.486 96.213 58.8617 98.0309 58.9041Z",
    fill: "#1B3554"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.0309 78.9529L118.6 78.1054C120.418 78.0295 121.892 79.4823 121.892 81.3505C121.892 83.2187 120.418 84.8302 118.6 84.9498L98.0309 86.2852C96.213 86.4017 94.7393 84.8373 94.7393 82.7913C94.7393 80.7452 96.213 79.0268 98.0309 78.9529Z",
    fill: "#1B3554"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3081 74.9947C78.011 74.7903 85.8768 66.5457 85.8768 56.5821C85.8768 46.6185 78.011 37.9882 68.3081 37.3131C58.6051 36.6462 50.7393 44.8972 50.7393 55.735C50.7393 66.5727 58.6051 75.1966 68.3081 74.9947Z",
    fill: "#7DFBA5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4904 63.1238C65.8247 63.4881 66.2617 63.6712 66.6994 63.6739C67.1372 63.6765 67.5741 63.4995 67.9084 63.1417L76.4587 54.186C77.1265 53.5026 77.1265 52.3627 76.4587 51.6354C75.791 50.9059 74.7085 50.8651 74.0407 51.5486L66.6994 59.2145L62.7783 54.8757C62.1105 54.1289 61.028 54.0982 60.3602 54.8114C59.6925 55.5269 59.6925 56.7154 60.3602 57.4622L65.4904 63.1238Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.739319,
    y: 0.657715,
    width: 239.521,
    height: 163.697,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 19
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.226735 0 0 0 0 0.437054 0 0 0 0 0.687819 0 0 0 0.189057 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.fde9fbf6a718cdb91cab8646ea362513.svg";
export { ForwardRef as ReactComponent };